import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import OfficeId              from "../../../domain/office/OfficeId";
import OfficeRepository      from "../../../domain/office/OfficeRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import OfficeDataSource      from "../../../infrastructure/datasource/office/OfficeDataSource";

class GetSelectedOffice {
  private readonly repository: OfficeRepository = new OfficeDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(callback: (officeId: OfficeId) => void) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.find();
      const officeId: OfficeId = new OfficeId(response.data.id);
      callback(officeId);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetSelectedOffice;
